import { Empresa } from './empresa';
import { JSONConverters } from './JSONConverters';

export class ConfiguracionFacturaSV {
    constructor(
        public id: number,
        public ultimaActualizacionFacturasSV: string,
        public historialActualizacionesFacturasSV: string,
        public alertas: string,
        //Relaciones
        public EmpresaId: number,
    ){
        this.cargarArrays();
        this.conversiones();
    }

    jsonConverts: JSONConverters = new JSONConverters();

    historialActualizacionesFacturasSVArray: string[];
    ultimaActualizacionFacturasSVFormato: string;

    alertasArray: { correo: string }[];

    Empresa: Empresa;

    cargarArrays() {
        this.historialActualizacionesFacturasSVArray = this.historialActualizacionesFacturasSV ? JSON.parse(this.historialActualizacionesFacturasSV) : [];

        this.alertasArray = this.alertas ? JSON.parse(this.alertas) : [];

    }

    cargarHorarios(){
        
    }

    conversiones(){
        
    }

}